/**Angular Libraries **/
import { Component, OnInit, OnDestroy, Output, EventEmitter, ElementRef, ViewChild, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Store, Action } from '@ngrx/store';
import { Subscription } from 'rxjs';
/**Services **/
// import { OCCPageState, OccSettingsTextState } from "../../../../../state-management/state/main-state";
import { OccCommonMethodsService } from '../../occ-services/occ-common-methods.service';
import { OccDispatchService } from '../../occ-services/occ-dispatch.service';
import { Utilities } from '../../../../../shared/outer-services/utilities.service';
import { StorageService } from '../../../../../shared/outer-services/storage.service';
import {
  Career_Detail_Related_Careers_State,
  Occ_EmpOutlook_Wages_State,
  Occ_Settings_Tab_Text_State,
} from '../../occ-state-management/occ-state/occ-state';
import { FrameworkConfigState } from '../../../../../state-management/state/main-state';
import html2pdf from 'html2pdf.js';
import { clusterDetails } from '../../../../../shared/constants/cluster-icons';
import { PdfPrintService } from 'app/shared/outer-services/pdf-print.service';

@Component({
  selector: 'related-careers',
  templateUrl: './related-careers-layout.html',
  standalone: false
})
export class RelatedCareersComponent implements OnInit, OnDestroy {
  @Output() changeViewRelate = new EventEmitter();
  hasMilitaryCareers: boolean = false; /** Show and hide milatary career */
  occCareerStore; /** Is a variable that is used to store data coming from reducer */
  occSettingsSub = new Subscription();
  occPageSub = new Subscription();
  settingsTextTab;
  occName;
  relCareerPrintsub: Subscription;
  printPage = false;
  settingsText; /** Is a variable that is used to store data coming from reducer */
  @ViewChild('RelatedCarees', { static: true }) RelatedCarees: ElementRef;

  @Input('logo') logo;
  @Input('careerTitle') careerTitle;
  @Input('tabTitle') tabTitle;
  @Input('frameWorkdata') frameWorkObj;
  @Input('showMilCareer') showMilCareer: boolean; /** To show mil careers in career detail */

  states: Array<string> = ['US', StorageService.staticSessionStorageGet('stateAbr')];
  langVal: string = StorageService.staticSessionStorageGet('langset')
    ? StorageService.staticSessionStorageGet('langset')
    : 'en';
  occALive: boolean = true;
  occID: number;

  constructor(
    private router: Router,
    private utils: Utilities,
    private storageService: StorageService,
    private activatedRoute: ActivatedRoute,
    private dispatchStore: Store<Action>,
    private occSetstore: Store<Occ_Settings_Tab_Text_State>,
    private relatedCareerStateStore: Store<Career_Detail_Related_Careers_State>,
    private occDispatch: OccDispatchService,
    private occCommonService: OccCommonMethodsService,
    private Frameworkstore: Store<FrameworkConfigState>,
    private pdfPrintService: PdfPrintService
  ) {

    this.relCareerPrintsub = this.occDispatch
      .careerRelatedListen()
      .subscribe(() => {
        // console.log('AGA called ---');
        this.utils.showLoading();
        this.careerPrint();
      });
    // Get data from reducer to show tab names and to check sections are available or not etc.,
    this.occSettingsSub = this.occSetstore
      .select('Occ_Settings_Tab_Text')
      .subscribe((occSettings) => {
        this.settingsText = occSettings;
        if (this.settingsText.Occ_Settings_Tab_Text.tabs) {
          const ref = this;
          this.settingsText.Occ_Settings_Tab_Text.tabs.forEach(
            function (obj, inx) {
              if (obj['tabId'] === 6) {
                ref.settingsTextTab = obj;
              }
            }.bind(this)
          );
        }
      });
    // Get data from reducer to display in cards
    this.occPageSub = this.relatedCareerStateStore
      .select('Career_Detail_Related_Careers')
      .subscribe((occWages) => {
        this.occCareerStore = occWages;
        if (this.occCareerStore.RelatedMilitary) {
          if (Array.isArray(this.occCareerStore.RelatedMilitary) && this.occCareerStore.RelatedMilitary.length > 0) {
            this.hasMilitaryCareers = true;
          } else {
            this.hasMilitaryCareers = false;
          }
        }
        if (this.occCareerStore.RelatedCareers && this.occCareerStore.RelatedCareers &&
          this.occCareerStore.RelatedCareers?.lists[1] &&
          this.occCareerStore.RelatedCareers?.lists[1].links) {
          this.occCareerStore.RelatedCareers?.lists[1].links.sort((a, b) => {
            const linkTitleA = a.linkTitle.toUpperCase();
            const linkTitleB = b.linkTitle.toUpperCase();

            if (linkTitleA < linkTitleB) {
              return -1;
            }
            if (linkTitleA > linkTitleB) {
              return 1;
            }
            return 0;
          });
        }
      });
  }
  ngOnInit() {

    this.storageService.sessionStorageSet('personalQua', 'no');
    this.activatedRoute.queryParams.subscribe((params) => {
      this.occName = params['occname'];
      this.occID = params['occid'];
    });

    try {
      this.dispatchStore.dispatch({
        type: 'GET_DETAIL_RELATED_CAREERS',
        payload: {
          methodVal: 'GET',
          module_Name: 'occ/v2/',
          path_params: ['occ', this.occID, 'accountID'],
          query_params: {
            sections: 'RelatedCareers,ParentCluster,RelatedMilitary,FindJobs', //this is to get all tab text
            states: this.states,
            lang: this.langVal,
          },
          body_Params: {},
          endUrlVal: 'pages',
        },
      });
    } catch (e) {
      console.log('error------>' + e.message);
    }
  }
  async careerPrint() {
    this.utils.showLoading();
    //render the loading spinner before print, to make sure the content is loaded before print.
    await new Promise(resolve => setTimeout(resolve, 0));

    const element = this.RelatedCarees.nativeElement;

    await this.pdfPrintService.exportElementToPdf(
      element,
      'Career - Related Careers.pdf',
      'portrait'
    );
    this.utils.hideLoading();
  }
  /** this ngOnDestroy() function is call after Component destory */
  ngOnDestroy() {
    //unsubscribe all the subscritions
    this.occSettingsSub.unsubscribe();
    this.occPageSub.unsubscribe();
    this.relCareerPrintsub.unsubscribe();
  }
  //Redirects to respective career page
  CallOccDetailCareer(id, name) {
    let clusterId;
    let clusterIcon;
    let backGroundClr;
    const val = JSON.parse(this.storageService.sessionStorageGet('OccIndexReducerText'));

    val.Occ_Index_Reducer_Text.occList.forEach(function (obj, inx) {
      if (obj.occID === id) {
        clusterId = (obj.clusterIDs && obj.clusterIDs.length > 0) ? obj.clusterIDs[0] : '110100'; //take the first clusterId
      }
    });
    const clsVal = this.occCommonService.clustDetails(clusterId);
    clusterIcon = clsVal.clusterIconValue;
    backGroundClr = clsVal.clusterBgColor;

    const twoDigit = id.toString().substr(0, 2);
    if (parseInt(twoDigit, 10) === 14) {
      this.router.navigate(['../occEmergCareer'], {
        relativeTo: this.activatedRoute,
        queryParams: {
          occid: id,
          occname: name,
          clusIcon: clusterIcon,
          clusColor: backGroundClr,
        },
      });
    } else {
      this.dispatchStore.dispatch({ type: 'RESET_OCC_SETTING_TABS_TEXT' });
      this.dispatchStore.dispatch({ type: 'RESET_OCC_PAGE' });
      const occArray = [id, name];
      this.router.navigate(['../occCareer'], {
        relativeTo: this.activatedRoute,
        queryParams: { occid: id, occname: name },
      });
      this.utils.showLoading();
      setTimeout(
        function () {
          const evnt = document.createEvent('CustomEvent');
          evnt.initEvent('relatedDispatch', true, true);
          this.occDispatch.dispatch(evnt);
        }.bind(this),
        100
      );
    }
  }

  //Redirects to respective cluster page
  CallOccDetailCluster(clusId: number, ClusName: string) {
    const clusterIcon = clusterDetails[`cls_${clusId}`].clusterIconValue;
    this.router.navigate(['../occCluster'], {
      relativeTo: this.activatedRoute,
      queryParams: {
        clusId: clusId,
        clusName: ClusName,
        clusIcon: clusterDetails[`cls_${clusId}`].clusterIconValue,
        clusColor: clusterDetails[`cls_${clusId}`].clusterBgColor
      },
    });
  }
  CallMilitaryCareer(id, name) {
    const occArray = [id, name];
    this.router.navigate(['../../military-details/militaryCareerHeader'], {
      relativeTo: this.activatedRoute,
      queryParams: { milid: id, milname: name },
    });
    this.utils.showLoading();
    setTimeout(
      function () {
        const evnt = document.createEvent('CustomEvent');
        evnt.initEvent('relatedDispatch', true, true);
        this.occDispatch.dispatch(evnt);
      }.bind(this),
      100
    );
  }
}
